import { DynamicOptionsWithNumberAndSelectionOption as DynamicOptionsWithNumberAndSelectionOptionType } from '../../../../../../types/Survey/Element'
import { Props } from './types'
import { useSelector } from 'react-redux'
import props from '../../../../../../redux/props'
import Input from '../../../../../UI/Input/Input'

const DynamicOptionsWithNumberAndSelectionOption: React.FC<Props<DynamicOptionsWithNumberAndSelectionOptionType>> = ({ element, update }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const set = (prop: keyof DynamicOptionsWithNumberAndSelectionOptionType) => (value: any) => {
    update({ ...element, [prop]: value })
  }

  return (
    <div>
      <div className="flex flex-row gap-2">
        <Input label={t.survey.configuration.dynamicOptionsWithNumberAndSelectionOption.name} value={element.name} onChange={set('name')} />
      </div>
    </div>
  )
}

export default DynamicOptionsWithNumberAndSelectionOption
